import React, { Fragment } from 'react';
import { appStructure } from 'helpers/navigationHelper';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';
import SectionTips from 'components/templates/SectionTips/SectionTips';

import TraitDetailsGroup from 'components/templates/TraitDetailsGroup/TraitDetailsGroup';
import Illustration from 'components/molecules/Illustration/Illustration';
import { PersonalityCreativity } from 'assets/iconsList';
import CirclePercentage from 'components/molecules/Circle/CirclePercentage';
import { beProductiveTipsAtom } from 'dataLayer/recoil/pages/sections/atoms';
import { Loadable } from 'dataLayer/recoil/Loadable';
import SwipeableView from 'components/molecules/SwipeableView/SwipeableView';
import RenderSectionProfile from 'pages/RenderSectionProfile/RenderSectionProfile';
import { beProductiveTraitsSelector } from 'dataLayer/recoil/pages/sections/selectors';

const BeProductiveTips = (props) => {
  const { data } = props;

  return (
    <Fragment>
      <SwipeableView id="swipeable-tips">
        {data.map((item) => (
          <SectionTips {...item} />
        ))}
      </SwipeableView>
    </Fragment>
  );
};

const BeProductiveProfile = (props) => {
  const reportData = {
    report_code: 'personality',
    language: 'en',
  };

  return <RenderSectionProfile data={props.data} reportData={reportData} />;
};

export default function BeProductiveSection(props) {
  const { data } = props;

  let { path } = useRouteMatch();

  const subsections = appStructure.sections[3].subsections;

  const icon = (
    <Illustration height="60%" width="60%">
      <PersonalityCreativity />
    </Illustration>
  );

  const circleStat = (
    <CirclePercentage
      label="Population percentile"
      value="77"
    ></CirclePercentage>
  );

  return (
    <Fragment>
      <Switch>
        <Route exact path={path}>
          <Redirect
            to={{
              pathname: subsections[0].route,
              state: { from: 'eat fresh initial' },
            }}
          />
        </Route>
        {/* <Route path={subsections[0].route}>
          <Fragment>
            <TraitDetailsGroup {...data.morning}>{[icon]}</TraitDetailsGroup>
          </Fragment>
        </Route>
        <Route path={subsections[1].route}>
          <Fragment>
            <TraitDetailsGroup {...data.social}>
              {[icon, circleStat]}
            </TraitDetailsGroup>
          </Fragment>
        </Route>
        <Route path={subsections[2].route}>
          <Fragment>
            <TraitDetailsGroup {...data.work}>
              {[icon, circleStat]}
            </TraitDetailsGroup>
          </Fragment>
        </Route> */}
        <Route
          path={subsections[0].route}
          render={() => (
            <Loadable
              value={beProductiveTipsAtom}
              component={BeProductiveTips}
            />
          )}
        />
        <Route
          path={subsections[1].route}
          render={() => (
            <Loadable
              value={beProductiveTraitsSelector}
              component={BeProductiveProfile}
            />
          )}
        />
      </Switch>
    </Fragment>
  );
}
